import Quill from "quill";
import { blogPdfFileName, sanitizeBlogPdfPath } from "./blogPdf";

const BlockEmbed = Quill.import("blots/block/embed");

class OaPdfBlot extends BlockEmbed {
    static blotName = "oaPdf";
    static tagName = "DIV";
    static className = "oa-pdf-embed";

    static create(value) {
        const node = super.create();
        const path = sanitizeBlogPdfPath(value);
        node.setAttribute("data-pdf-url", path);
        if (path) {
            node.setAttribute("data-pdf-label", blogPdfFileName(path));
        }
        node.setAttribute("contenteditable", "false");
        return node;
    }

    static value(domNode) {
        return sanitizeBlogPdfPath(domNode.getAttribute("data-pdf-url") || "");
    }
}

/** Not uploaded until the post is saved — file is held in `pendingPdfFilesRef` (Map id → File). */
class OaPdfPendingBlot extends BlockEmbed {
    static blotName = "oaPdfPending";
    static tagName = "DIV";
    static className = "oa-pdf-pending";

    static create(value) {
        const node = super.create();
        let id = "";
        let label = "document.pdf";
        try {
            const o = typeof value === "string" ? JSON.parse(value) : value;
            id = String(o?.id || "").trim();
            label = String(o?.name || "document.pdf").trim() || "document.pdf";
        } catch {
            /* ignore */
        }
        if (id) {
            node.setAttribute("data-pdf-pending-id", id);
            node.setAttribute("data-pdf-label", label);
            node.setAttribute("title", "Preview locally — uploads when you save the post");
        }
        node.setAttribute("contenteditable", "false");
        return node;
    }

    static value(domNode) {
        const id = domNode.getAttribute("data-pdf-pending-id") || "";
        const name = domNode.getAttribute("data-pdf-label") || "document.pdf";
        return JSON.stringify({ id, name });
    }
}

/** Inline image — not uploaded until the post is saved (file in `pendingImageFilesRef`). */
class OaImagePendingBlot extends BlockEmbed {
    static blotName = "oaImagePending";
    static tagName = "DIV";
    static className = "oa-image-pending";

    static create(value) {
        const node = super.create();
        let id = "";
        let label = "image";
        try {
            const o = typeof value === "string" ? JSON.parse(value) : value;
            id = String(o?.id || "").trim();
            label = String(o?.name || "image").trim() || "image";
        } catch {
            /* ignore */
        }
        if (id) {
            node.setAttribute("data-image-pending-id", id);
            node.setAttribute("data-image-label", label);
            node.setAttribute("title", "Preview locally — uploads when you save the post");
        }
        node.setAttribute("contenteditable", "false");
        return node;
    }

    static value(domNode) {
        const id = domNode.getAttribute("data-image-pending-id") || "";
        const name = domNode.getAttribute("data-image-label") || "image";
        return JSON.stringify({ id, name });
    }
}

let registered = false;

export function registerQuillPdfBlot() {
    if (registered) return;
    Quill.register(OaPdfBlot, true);
    Quill.register(OaPdfPendingBlot, true);
    Quill.register(OaImagePendingBlot, true);
    registered = true;
}
